import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "../DataTable";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import CustomSpinner from "layouts/ProgressBar";
import Icon from "@mui/material/Icon";
import MDButton from "components/MDButton";
import Notification from "layouts/Notification";
import { getcommunitiesList } from "redux/actions/communityActions";
import { Percent } from "@mui/icons-material";

function Communities({ userDetails, getcommunitiesList, successReducer, communityListReducer }) {
  const [communitiesList, setCommunitiesList] = useState([]);

  useEffect(() => {
    getcommunitiesList();
  }, []);

  useEffect(() => {
    if (communityListReducer?.communityList) {
      let tempData =
        communityListReducer?.communityList.map((mainCom) => {
          var admins = "";
          mainCom?.community
            ? mainCom?.community?.communityAdmins?.forEach(
              (adm) => { admins = admins + adm.userName + ", " }
            )
            : mainCom?.subCommunity?.communityAdmins?.forEach(
              (adm) => { admins = admins + adm.userName + ", " }
            );


          let description = mainCom?.community
            ? mainCom?.community?.description
            : mainCom?.subCommunity?.description;

          admins = admins.substring(0, admins.lastIndexOf(`, `))

          let communityAdmins = admins;
          let sortCommunityAdmins = admins;
          if (admins.length > 25) {
            sortCommunityAdmins = admins.substring(0, 25) + "..."
          }
          return {
            id: mainCom?.community?.communityId,

            type: mainCom.type,

            communityName: mainCom?.community
              ? mainCom?.community?.communityName
              : mainCom?.subCommunity?.subCommunityName,

            description: description,
            sortDescription: description.substring(0, 25) + "...",

            privacy: mainCom?.community
              ? mainCom?.community?.communityPrivacy
              : mainCom?.subCommunity?.subCommunityPrivacy,

            communityAdmins: communityAdmins,
            sortCommunityAdmins: sortCommunityAdmins,

            percentCommunity: mainCom?.subCommunity ? mainCom?.subCommunity.communityName : "",
            // subCom: mainCom?.community
            //   ? communityListReducer?.communityList.filter(
            //     (subCom) => subCom?.subCommunity?.communityId === mainCom.community.communityId
            //   )
            //   : [],
          };
        })

      setCommunitiesList(tempData);
    }
  }, [communityListReducer]);

  useEffect(() => {
    if (successReducer?.message) {
      setTimeout(() => {
        clearEventResponce();
      }, 1000);
    }
  }, [successReducer]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    Communities
                  </MDTypography>
                  {/* <Link to='/event'><MDButton
                    // fullWidth
                    variant="outlined"
                    size="small"
                    color="white">
                    Add Event
                  </MDButton>
                  </Link> */}
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                {communityListReducer?.loading ? (
                  <CustomSpinner />
                ) : (
                  <DataTable
                    table={{
                      columns: [
                        { Header: "Name", accessor: "communityName", width: "16%" },
                        {
                          Header: "Description",
                          accessor: "sortDescription",
                          width: "16%",
                          Cell: props => {
                            return <MDBox display="flex" justifyContent="end" alignItems="center" >
                              <Tooltip title={props.row.original.description} placement="top">
                                <MDTypography variant="body2" color="secondary">
                                  <div>{props.row.original.sortDescription}</div>
                                </MDTypography>
                              </Tooltip>
                            </MDBox>
                          }
                        },
                        { Header: "Privacy", accessor: "privacy", width: "16%" },
                        {
                          Header: "Organized by",
                          accessor: "communityAdmins",
                          width: "16%",

                          Cell: props => {
                            return <MDBox display="flex" justifyContent="end" alignItems="center" >
                              <Tooltip title={props.row.original.communityAdmins} placement="top">
                                <MDTypography variant="body2" color="secondary">
                                  <div>{props.row.original.sortCommunityAdmins}</div>
                                </MDTypography>
                              </Tooltip>
                            </MDBox>
                          }
                        },
                        { Header: "Parent community", accessor: "percentCommunity", width: "16%" },
                        {
                          Header: "Action",
                          accessor: "action",
                          Cell: props => {
                            return (userDetails.userId === props.row.original.userId ?
                              <MDBox display="flex" justifyContent="end" alignItems="center" >
                                <Link to={'/event/' + props.row.original.eventId} >
                                  <Tooltip title="Edit" placement="top">
                                    <MDTypography variant="body2" color="secondary">
                                      <Icon>edit</Icon>
                                    </MDTypography>
                                  </Tooltip>
                                </Link>
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                <Tooltip title="Delete" placement="top" >
                                  <MDTypography variant="body2" color="secondary">
                                    <Icon>delete</Icon>
                                  </MDTypography>
                                </Tooltip>
                              </MDBox>
                              : <></>
                            )
                          },
                          width: "10%"
                        },
                      ],
                      rows: communitiesList,
                    }}
                    entriesPerPage={true}
                    pagination={true}
                    isSorted={true}
                    noEndBorder={true}
                    canSearch={true}
                    showTotalEntries={true}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {
        successReducer?.message && (
          <Notification
            color="success"
            icon="check"
            title={successReducer.message}
            content={successReducer.Description}
            dateTime=""
          />
        )
      }
      <Footer />
    </DashboardLayout >
  );
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.logedinUserReducer.userDetails,
    communityListReducer: state.communityListReducer,
    successReducer: state.successReducer,
  };
};

export default connect(mapStateToProps, { getcommunitiesList })(Communities);
